import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Input, Row, Col } from "antd";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";

function ProfileAdmin({ currentUser }) {
  return (
    <>
      <Formik
        initialValues={{
          name: currentUser.data.full_name,
          email: currentUser.data.email,
        }}
        enableReinitialize={true}
      >
        {(formikProps) => {
          return (
            <>
              <Row>
                <Col span={12} className="column-left">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="Name"
                    hideErrorMessage={true}
                    value={formikProps.values.name}
                    className="text-field"
                    disabled={true}
                    placeholder={"—"}
                  />
                </Col>
                <Col span={12} className="column-right">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="Email"
                    hideErrorMessage={true}
                    value={formikProps.values.email}
                    className="text-field"
                    disabled={true}
                    placeholder={"—"}
                  />
                </Col>
              </Row>
            </>
          );
        }}
      </Formik>
    </>
  );
}

const mapStateToProps = ({ user: { currentUser } }) => ({ currentUser });

ProfileAdmin.propTypes = {
  currentUser: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(ProfileAdmin);
